import { basicValidation } from '../basicValidation';

export const miscFieldValidation = {
    userNotification: {
        userId: (value: string) => basicValidation.resourceId.isValid(value),
        notificationId: (value: string) => basicValidation.resourceId.isValid(value)
    },

    confirmationRequest: {
        id: (value: string) => basicValidation.resourceId.isValid(value)
    },

    organizationOwner: {
        firstname: (value: string) => basicValidation.resourceText.isValid(value, true, 100),
        middlename: (value: string) => basicValidation.resourceText.isValid(value, true, 100),
        lastname: (value: string) => basicValidation.resourceText.isValid(value, true, 100)
    },

    workgroup: {
        id: (value: string) => basicValidation.resourceId.isValid(value),
        parentIdOrNone: (value: string) => basicValidation.resourceId.isValidOrEmpty(value),
        type: (value: 'committee' | 'workgroup') =>
        {
            if (!value)
                return false;
            return ['committee', 'workgroup'].find(v => v === value) !== undefined;
        },
        name: (value: string) => basicValidation.resourceText.isValid(value, false, 100)
    },
};